"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _theme = require("HubStyleTokens/theme");

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var _NestedNavItem = _interopRequireDefault(require("ecosystem-marketplace-core/components/nav/NestedNavItem"));

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  &.unstyled-nested-nav-item {\n    && {\n      font-size: inherit;\n      ", "\n\n      &,\n      &:hover {\n        background-color: transparent;\n      }\n    }\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  color: ", ";\n\n  &:hover {\n    color: ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var linkStyles = (0, _styledComponents.css)(_templateObject(), _theme.BASE_LINK_COLOR, _theme.BASE_LINK_HOVER_COLOR);
var UnstyledNestedNavItemLink = (0, _styledComponents.default)(function (props) {
  var Link = props._linkComponent,
      className = props.className,
      __use = props.use,
      rest = (0, _objectWithoutProperties2.default)(props, ["_linkComponent", "className", "use"]);
  var itemClasses = (0, _classnames.default)('unstyled-nested-nav-item', className);
  return _react.default.createElement(Link, (0, _extends2.default)({}, rest, {
    className: itemClasses
  }));
}).withConfig({
  displayName: "UnstyledNestedNavItem__UnstyledNestedNavItemLink",
  componentId: "sc-1sb9no1-0"
})(_templateObject2(), function (props) {
  return props.use === 'link' ? linkStyles : '';
});
UnstyledNestedNavItemLink.propTypes = {
  _linkComponent: _propTypes.default.elementType,
  className: _propTypes.default.string,
  use: _propTypes.default.oneOf(['unstyled', 'link'])
};
UnstyledNestedNavItemLink.defaultProps = {
  _linkComponent: _UILink.default,
  use: 'unstyled'
};

var UnstyledNestedNavItem = function UnstyledNestedNavItem(props) {
  return _react.default.createElement(_NestedNavItem.default, (0, _extends2.default)({}, props, {
    linkComponent: UnstyledNestedNavItemLink
  }));
};

var _default = UnstyledNestedNavItem;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/storefront/sidebar/inputs/UnstyledNestedNavItem.js
// module id = 265
// module chunks = 209 210 211 212